import { useEffect, useState } from 'react';
import { io, Socket } from 'socket.io-client';
import { useLanguageSync } from '../../hooks/useLanguageSync';
import { getServerUrl } from '../../lib/getServerUrl';

/**
 * Hook per connessione Socket.IO admin
 */
export function useAdminSocket(sessionId: string | undefined) {
  const [socket, setSocket] = useState<Socket | null>(null);
  const [isConnected, setIsConnected] = useState(false);

  // Sync language changes from server
  useLanguageSync(socket, isConnected);

  useEffect(() => {
    if (!sessionId) return;

    // Get auth token from localStorage
    const token = localStorage.getItem('adminToken');

    // Connect to Socket.IO admin namespace with auth token (usa VITE_API_URL per Railway, altrimenti hostname:3000 per LAN)
    const serverUrl = getServerUrl('admin');
    const newSocket = io(serverUrl, {
      transports: ['websocket', 'polling'],
      auth: { token },
    });

    setSocket(newSocket);

    newSocket.on('connect', () => {
      console.log('[ADMIN] Connected to Socket.IO');
      setIsConnected(true);

      // Join session room
      newSocket.emit('admin:join-session', {
        sessionId,
      });
    });

    newSocket.on('admin:joined', (data: any) => {
      console.log('[ADMIN] Joined session:', data.sessionId);
    });

    newSocket.on('disconnect', () => {
      console.log('[ADMIN] Disconnected from Socket.IO');
      setIsConnected(false);
    });

    newSocket.on('admin:error', (data: any) => {
      console.error('[ADMIN] Error:', data.message);
      alert(`Error: ${data.message}`);
    });

    return () => {
      newSocket.disconnect();
    };
  }, [sessionId]);

  return {
    socket,
    isConnected,
  };
}
